import axios, { AxiosResponse } from "axios";
import { getErrorMsg } from "../common/utils/request";
import { startLoading, stopLoading } from "../common/deletion-loading";
import { masonryOpts } from "../common/config";
import { BaseResponse } from "../common/interfaces/responses";

declare var pm: PmInterface;
declare var FlexMasonry: any;

export default function deletePhoto(
	photoId: number | string,
	isReview?: boolean,
) {
	const { findHtmlEl, findImgEl } = pm.utils.dom;

	const isAuthorPage = document.body.classList.contains("author");
	let doingAjax = false;

	const grid = findHtmlEl(".photo-grid");
	if (!grid) return;

	const imageWrapper = findHtmlEl(
		".grid-image-wrapper[data-photo-id='" + photoId + "']",
	);
	if (!imageWrapper) return;

	if (!confirm("Are you sure you want to delete this photo?")) return;

	if (doingAjax) return;
	doingAjax = true;

	startLoading(imageWrapper);

	const formData = new FormData();

	formData.append("action", "pm_delete_photo");
	formData.append("nonce", pm.nonces.deletePhoto);
	formData.append("photo_id", photoId.toString());

	if (isReview) {
		formData.append("is_review", "1");
	}

	axios({
		method: "post",
		url: pm.ajaxurl,
		data: formData,
	})
		.then((response: AxiosResponse<BaseResponse>) => {
			const photo = findImgEl(imageWrapper, ".grid-image");

			if (isAuthorPage) {
				pm.event.emit("pm_album_update_total_photos", {
					albumSlug: photo?.dataset.albumSlug,
					action: "decrease",
					impactAllPhotosAlbum: true,
				});
			}

			const parentEl = imageWrapper.parentElement;

			if (parentEl) grid.removeChild(parentEl);
			FlexMasonry.refresh(grid, masonryOpts);
		})
		.catch((response: AxiosResponse<any>) => {
			const errorMsg = getErrorMsg(response);
			console.error(errorMsg);
		})
		.then(() => {
			doingAjax = false;
			stopLoading(imageWrapper);
		});
}
